<template>
  <component :is="tag" :class="[className, currentTheme]" :style="`${borderBottomRadius};`">
    <slot></slot>
  </component>
</template>

<script>
/**
 * @class CardHeader
 *
 * @description this component is a wrapper for bootstrap "panel-heading"
 */
export default {
  name: 'CardHeader',
  props: {
    tag: {
      type: String,
      default: 'div',
    },
    className: {
      type: String,
      default: 'panel-heading',
    },
    currentTheme: {
      type: String,
      default: '',
    },
    collapsed: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    borderBottomRadius() {
      return this.collapsed
        ? 'border-bottom-left-radius:.3rem;border-bottom-right-radius:.3rem;-webkit-border-bottom-left-radius:.3rem;-webkit-border-bottom-right-radius:.3rem;'
        : ''
    },
  },
}
</script>

<style scoped lang="scss">
.panel-heading.default {
  background-color: $default-panel-header-bg;
}
.panel-heading.blue {
  background-color: $blue-panel-header-bg;
}
.panel-heading.green {
  background-color: $green-panel-header-bg;
}
.panel-heading.orange {
  background-color: $orange-panel-header-bg;
}
.panel-heading.pink {
  background-color: $pink-panel-header-bg;
}
.panel-heading.red {
  background-color: $red-panel-header-bg;
}
</style>
